import { z } from 'zod';
import { eventSchema } from './envelope';

export const EXAMPLE_NOTE_CREATED_V1 = 'example.note.created.v1' as const;

export const exampleNoteCreatedV1Schema = eventSchema({
  noteId: z.guid(),
  text: z.string(),
});
export type ExampleNoteCreatedV1 = z.infer<typeof exampleNoteCreatedV1Schema>;

export const exampleEventCatalog = {
  [EXAMPLE_NOTE_CREATED_V1]: exampleNoteCreatedV1Schema,
} as const;
